enum ChatMessageContentType {
  ACTION_PROPOSAL = "ACTION_PROPOSAL",
  BRIEF = "BRIEF",
  CALL_CARD = "CALL_CARD",
  DEBRIEF = "DEBRIEF",
  RECORD_CARD = "RECORD_CARD",
  RECORD_LIST = "RECORD_LIST",
  ROUTE_CARD = "ROUTE_CARD",
  SYSTEM_NOTICE = "SYSTEM_NOTICE",
  TEXT = "TEXT",
  UNSUPPORTED = "UNSUPPORTED", // FE-only: unknown type, or a payload we could not parse
}

export default ChatMessageContentType;
